import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g strokeWidth={1.2}>
      <path
        strokeLinecap="round"
        d="m4.5 9.5 2.592.883c1.08-.123 3.443.287 4.258 2.91l2.616 2.24c.714.61.84 1.667.291 2.43a.187.187 0 0 1-.266.038l-4.33-3.375"
      />
      <path
        strokeLinecap="round"
        d="m1.757 14.28.874.25a9.4 9.4 0 0 1 3.503 1.884l1.257 1.076a13.45 13.45 0 0 0 5.034 2.708l2.162.62c.21.06.43.08.647.059l3.719-.372a1.16 1.16 0 1 0-.243-2.306L16 18.5"
      />
      <path
        strokeLinejoin="round"
        d="M14.279 3.5v2.779H11.5a.5.5 0 0 0-.5.5v2.278a.5.5 0 0 0 .5.5h2.779V12.5a.5.5 0 0 0 .5.5h2.606a.5.5 0 0 0 .5-.5V9.557H20.5a.5.5 0 0 0 .5-.5V6.78a.5.5 0 0 0-.5-.5h-2.615V3.5a.5.5 0 0 0-.5-.5H14.78a.5.5 0 0 0-.5.5Z"
        style={{
          stroke: "var(--icon-accent,#E47B53)",
        }}
      />
    </g>
  </svg>
);
export const HealthDayIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
